import { getThumbnail } from './util/image'

import qs from 'query-string'

const reg = /^imageMogr2|imageView2/
const host = 'ulms.idufep.com'
export default {
  install (Vue, options) {
    /**
     * @param src {string}
     */
    Vue.prototype.$getThumbnail = function (src, w, h) {
      if (typeof src !== 'string') {
        src = ''
      }
      if (!/^http/.test(src)) {
        src = 'http://' + host + (src[0] === '/' ? '' : '/') + src
      }
      const { url, query } = qs.parseUrl(src)
      const location = new URL(url)
      if (location.host !== host) {
        return src
      }
      Object.keys(query).forEach(key => {
        if (reg.test(key)) {
          query[key] = undefined
        }
      })
      query[getThumbnail(w, h)] = null
      return url + '?' + qs.stringify(query)
    }
  }
}
